import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

import { initSentry } from './lib/sentry';
import { initAnalytics } from './lib/analytics';
import { ErrorBoundary } from './components/ui/ErrorBoundary';
import { bootstrapTheme } from './hooks/useTheme';

// M-379: Apply stored theme synchronously before first paint to avoid flash
bootstrapTheme();

// Initialise observability BEFORE rendering — captures errors from first paint
initSentry();
initAnalytics();

const root = document.getElementById('root');
if (root) {
  ReactDOM.createRoot(root as HTMLElement).render(
    <React.StrictMode>
      <ErrorBoundary>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    </React.StrictMode>
  );
}
